import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "../../assets/logo.png";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import styles from "./Header.module.scss";

const navigationItems = [
  {
    id: "about",
    type: "route",
    to: "/about",
  },
  {
    id: "training",
    type: "anchor",
    href: "/about#trainings",
  },
  {
    id: "news",
    type: "route",
    to: "/news",
  },
  {
    id: "gallery",
    type: "route",
    to: "/gallery",
  },
  {
    id: "league",
    type: "route",
    to: "/league",
  },
  {
    id: "contact",
    type: "route",
    to: "/contact",
  },
];

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuIsOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuIsOpen]);

  const toggleMenu = () => {
    setMenuIsOpen((prev) => !prev);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const goToAboutTop = () => {
    setMenuIsOpen(false);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ""}`}>
      <div className={styles.logo}>
        <Link to="/about">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>

      <nav className={styles.nav}>
        <ul className={styles.navList}>
          {navigationItems.map((item) => (
            <li key={item.id}>
              {item.type === "route" ? (
                <NavLink
                  to={item.to}
                  onClick={item.id === "about" ? goToAboutTop : undefined}
                >
                  {t(item.id)}
                </NavLink>
              ) : (
                <a href={item.href}>{t(item.id)}</a>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <div className={styles.langSwitcher}>
        <LanguageSwitcher currentLang={i18n.language} onChange={changeLanguage} />
      </div>

      <button className={styles.menuBtn} onClick={toggleMenu} aria-label="Menu">
        {menuIsOpen ? <X size={28} /> : <Menu size={28} />}
      </button>

      {menuIsOpen && (
        <div className={styles.overlay}>
          <button
            type="button"
            className={styles.overlayBackdrop}
            onClick={toggleMenu}
            aria-label="Close menu"
          />

          <div className={styles.overlayPanel}>
            <nav className={styles.overlayNav}>
              {navigationItems.map((item) =>
                item.type === "route" ? (
                  <NavLink
                    key={item.id}
                    to={item.to}
                    onClick={item.id === "about" ? goToAboutTop : toggleMenu}
                  >
                    {t(item.id)}
                  </NavLink>
                ) : (
                  <a key={item.id} href={item.href} onClick={toggleMenu}>
                    {t(item.id)}
                  </a>
                )
              )}
            </nav>

            <div className={styles.overlayLang}>
              <LanguageSwitcher
                currentLang={i18n.language}
                onChange={changeLanguage}
              />
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
